import _forEach from "ramda/es/forEach";
import _curry from "ramda/es/curry";
import parseInt10 from './parseInt10';
export default _curry(function (dividend, divisor) {
  var div = '';
  var remainder = '';

  _forEach(function (char) {
    var operator = "".concat(remainder).concat(div).concat(char);

    if (operator < parseInt10(divisor)) {
      div += char;
    } else {
      remainder = operator % divisor || '';
      div = '';
    }
  }, dividend);

  remainder += div;
  return remainder === '' ? 0 : parseInt10(remainder);
});